import React from 'react';
import PropTypes from 'prop-types';
import InlineValidationMessage from '@ids/inline-validation-message';
import { currencyFormatter } from '../Util/CommonUtils';

// eslint-disable-next-line require-jsdoc
const SimpleStartingAtPriceBlock = (props) => {
  const { pricing, showQuantity, error, HideOtherQuanties } = props;

  if (error) {
    return (
      <p className="prod-sub-header margin-bottom-20">
        <InlineValidationMessage type="error" message="Unable to obtain the pricing information." />
      </p>
    );
  }

  if (pricing) {
    return pricing.DiscPrice ? (
      <p className="prod-sub-header margin-bottom-20">
        Starting at <s>{pricing ? currencyFormatter(pricing.ListPrice) : 0}</s>{' '}
        <span style={{ fontSize: '20px', fontWeight: '500', color: '#2ca01c' }}>
          {pricing ? pricing.DiscPrice : 0}{' '}
        </span>
        {showQuantity &&
          pricing.Quantity.length > 0 &&
          `for ${pricing.Quantity}${HideOtherQuanties ? '' : ', other quantities available'}`}
      </p>
    ) : (
      <p className="prod-sub-header margin-bottom-20">
        Starting at {pricing ? currencyFormatter(pricing.ListPrice) : 0}{' '}
        {showQuantity &&
          pricing.Quantity.length > 0 &&
          `for ${pricing.Quantity}${HideOtherQuanties ? '' : ', other quantities available'}`}
      </p>
    );
  }

  return null;
};

SimpleStartingAtPriceBlock.propTypes = {
  pricing: PropTypes.object,
  showQuantity: PropTypes.object,
  error: PropTypes.bool,
};

export default SimpleStartingAtPriceBlock;
